<template>
    <div>
        <div class="fileupload">
            <div v-if="variantAttribute" class="load-block">
                <span class="file-upload-trigger" @click="openModalFileUpload">
                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.6475 10.6158L11.8855 19.3778C9.93289 21.3304 6.76706 21.3304 4.81444 19.3778C2.86182 17.4252 2.86182 14.2594 4.81444 12.3068L12.9462 4.17503C14.313 2.80819 16.5291 2.80819 17.8959 4.17503C19.2628 5.54186 19.2628 7.75794 17.8959 9.12478L10.1024 16.9183C9.32132 17.6994 8.05499 17.6994 7.27394 16.9183C6.4929 16.1373 6.49289 14.8709 7.27394 14.0899L14.468 6.89585" stroke="#6087A0" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    <b>{{ getLocText('upload_file') }}</b>
                </span>
            </div>
            <b-tabs class="inside-content">
                <b-tab active>
                    <template #title>
                        {{ getFileTypeByCode('1001') }} (<span>{{(contractFiles && contractFiles.length > 0) ? contractFiles.length : 0}}</span>)
                    </template>
                    <b-table
                        :fields="fileTableFields"
                        :items="fileItems(contractFiles)"
                        small
                        hover
                        class="files-table"
                        no-sort-reset
                        :empty-text="getFmText('no_files')"
                        show-empty
                    >
                        <template #cell(file_name)="data">
                            <span class="col-file-cell">
                                <file-icons :filename="data.item.file_name"></file-icons>
                                <span @click="previewFile(data.item.file_name)"
                                        class="fileupload_file-name"
                                        :title="getTitleText(data.item.file_name)">{{data.item.file_name}}</span>
                                <span :class="['file-download-btn', { 'file-download-btn--disabled': getIsDownloading(data.item.id) }]" @click="downloadFile(data.item.file_name, data.item.id)">
                                    <file-download-ring v-if="getIsDownloading(data.item.id)" :progress="getDownloadProgress(data.item.id)"></file-download-ring>
                                    <i v-else class="icon icon-download"></i>
                                    <span>{{ getLocText('download_file') }}</span>
                                </span>
                            </span>
                        </template>
                        <template #cell(curr_ver)="data">
                            <span v-if="data.item.curr_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(past_ver)="data">
                            <span v-if="data.item.past_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(actions)="data">
                            <span v-if="showDeleteLinks || variantAttribute" class="col-delete"
                                  @click="delFile(data.item.category, data.item.id, data.item.file_name, getArrayByCategory(data.item.category))">
                                <i class="icon icon-close"></i>
                            </span>
                        </template>
                    </b-table>
                </b-tab>
                <b-tab>
                    <template #title>
                        {{ getFileTypeByCode('1002') }} (<span>{{(comOfferFiles && comOfferFiles.length > 0) ? comOfferFiles.length : 0}}</span>)
                    </template>
                    <b-table
                        :fields="fileTableFields"
                        :items="fileItems(comOfferFiles)"
                        small
                        hover
                        class="files-table"
                        no-sort-reset
                        :empty-text="getFmText('no_files')"
                        show-empty
                    >
                        <template #cell(file_name)="data">
                            <span class="col-file-cell">
                                <file-icons :filename="data.item.file_name"></file-icons>
                                <span @click="previewFile(data.item.file_name)"
                                        class="fileupload_file-name"
                                        :title="getTitleText(data.item.file_name)">{{data.item.file_name}}</span>
                                <span :class="['file-download-btn', { 'file-download-btn--disabled': getIsDownloading(data.item.id) }]" @click="downloadFile(data.item.file_name, data.item.id)">
                                    <file-download-ring v-if="getIsDownloading(data.item.id)" :progress="getDownloadProgress(data.item.id)"></file-download-ring>
                                    <i v-else class="icon icon-download"></i>
                                    <span>{{ getLocText('download_file') }}</span>
                                </span>
                            </span>
                        </template>
                        <template #cell(curr_ver)="data">
                            <span v-if="data.item.curr_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(past_ver)="data">
                            <span v-if="data.item.past_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(actions)="data">
                            <span v-if="showDeleteLinks || variantAttribute" class="col-delete"
                                  @click="delFile(data.item.category, data.item.id, data.item.file_name, getArrayByCategory(data.item.category))">
                                <i class="icon icon-close"></i>
                            </span>
                        </template>
                    </b-table>
                </b-tab>
                <b-tab>
                    <template #title>
                        {{ getFileTypeByCode('1003') }} (<span>{{(actFiles && actFiles.length > 0) ? actFiles.length : 0}}</span>)
                    </template>
                    <b-table
                        :fields="fileTableFields"
                        :items="fileItems(actFiles)"
                        small
                        hover
                        class="files-table"
                        no-sort-reset
                        :empty-text="getFmText('no_files')"
                        show-empty
                    >
                        <template #cell(file_name)="data">
                            <span class="col-file-cell">
                                <file-icons :filename="data.item.file_name"></file-icons>
                                <span @click="previewFile(data.item.file_name)"
                                        class="fileupload_file-name"
                                        :title="getTitleText(data.item.file_name)">{{data.item.file_name}}</span>
                                <span :class="['file-download-btn', { 'file-download-btn--disabled': getIsDownloading(data.item.id) }]" @click="downloadFile(data.item.file_name, data.item.id)">
                                    <file-download-ring v-if="getIsDownloading(data.item.id)" :progress="getDownloadProgress(data.item.id)"></file-download-ring>
                                    <i v-else class="icon icon-download"></i>
                                    <span>{{ getLocText('download_file') }}</span>
                                </span>
                            </span>
                        </template>
                        <template #cell(curr_ver)="data">
                            <span v-if="data.item.curr_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(past_ver)="data">
                            <span v-if="data.item.past_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(actions)="data">
                            <span v-if="showDeleteLinks || variantAttribute" class="col-delete"
                                  @click="delFile(data.item.category, data.item.id, data.item.file_name, getArrayByCategory(data.item.category))">
                                <i class="icon icon-close"></i>
                            </span>
                        </template>
                    </b-table>
                </b-tab>
                <b-tab>
                    <template #title>
                        {{ getFileTypeByCode('1004') }} (<span>{{(estimateFiles && estimateFiles.length > 0) ? estimateFiles.length : 0}}</span>)
                    </template>
                    <b-table
                        :fields="fileTableFields"
                        :items="fileItems(estimateFiles)"
                        small
                        hover
                        class="files-table"
                        no-sort-reset
                        :empty-text="getFmText('no_files')"
                        show-empty
                    >
                        <template #cell(file_name)="data">
                            <span class="col-file-cell">
                                <file-icons :filename="data.item.file_name"></file-icons>
                                <span @click="previewFile(data.item.file_name)"
                                        class="fileupload_file-name"
                                        :title="getTitleText(data.item.file_name)">{{data.item.file_name}}</span>
                                <span :class="['file-download-btn', { 'file-download-btn--disabled': getIsDownloading(data.item.id) }]" @click="downloadFile(data.item.file_name, data.item.id)">
                                    <file-download-ring v-if="getIsDownloading(data.item.id)" :progress="getDownloadProgress(data.item.id)"></file-download-ring>
                                    <i v-else class="icon icon-download"></i>
                                    <span>{{ getLocText('download_file') }}</span>
                                </span>
                            </span>
                        </template>
                        <template #cell(curr_ver)="data">
                            <span v-if="data.item.curr_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(past_ver)="data">
                            <span v-if="data.item.past_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(actions)="data">
                            <span v-if="showDeleteLinks || variantAttribute" class="col-delete"
                                  @click="delFile(data.item.category, data.item.id, data.item.file_name, getArrayByCategory(data.item.category))">
                                <i class="icon icon-close"></i>
                            </span>
                        </template>
                    </b-table>
                </b-tab>
                <b-tab>
                    <template #title>
                        {{ getFileTypeByCode('1005') }} (<span>{{(planFiles && planFiles.length > 0) ? planFiles.length : 0}}</span>)
                    </template>
                    <b-table
                        :fields="fileTableFields"
                        :items="fileItems(planFiles)"
                        small
                        hover
                        class="files-table"
                        no-sort-reset
                        :empty-text="getFmText('no_files')"
                        show-empty
                    >
                        <template #cell(file_name)="data">
                            <span class="col-file-cell">
                                <file-icons :filename="data.item.file_name"></file-icons>
                                <span @click="previewFile(data.item.file_name)"
                                        class="fileupload_file-name"
                                        :title="getTitleText(data.item.file_name)">{{data.item.file_name}}</span>
                                <span :class="['file-download-btn', { 'file-download-btn--disabled': getIsDownloading(data.item.id) }]" @click="downloadFile(data.item.file_name, data.item.id)">
                                    <file-download-ring v-if="getIsDownloading(data.item.id)" :progress="getDownloadProgress(data.item.id)"></file-download-ring>
                                    <i v-else class="icon icon-download"></i>
                                    <span>{{ getLocText('download_file') }}</span>
                                </span>
                            </span>
                        </template>
                        <template #cell(curr_ver)="data">
                            <span v-if="data.item.curr_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(past_ver)="data">
                            <span v-if="data.item.past_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(actions)="data">
                            <span v-if="showDeleteLinks || variantAttribute" class="col-delete"
                                  @click="delFile(data.item.category, data.item.id, data.item.file_name, getArrayByCategory(data.item.category))">
                                <i class="icon icon-close"></i>
                            </span>
                        </template>
                    </b-table>
                </b-tab>
                <b-tab>
                    <template #title>
                        {{ getFileTypeByCode('1006') }} (<span>{{(conclusionFiles && conclusionFiles.length > 0) ? conclusionFiles.length : 0}}</span>)
                    </template>
                    <b-table
                        :fields="fileTableFields"
                        :items="fileItems(conclusionFiles)"
                        small
                        hover
                        class="files-table"
                        no-sort-reset
                        :empty-text="getFmText('no_files')"
                        show-empty
                    >
                        <template #cell(file_name)="data">
                            <span class="col-file-cell">
                                <file-icons :filename="data.item.file_name"></file-icons>
                                <span @click="previewFile(data.item.file_name)"
                                        class="fileupload_file-name"
                                        :title="getTitleText(data.item.file_name)">{{data.item.file_name}}</span>
                                <span :class="['file-download-btn', { 'file-download-btn--disabled': getIsDownloading(data.item.id) }]" @click="downloadFile(data.item.file_name, data.item.id)">
                                    <file-download-ring v-if="getIsDownloading(data.item.id)" :progress="getDownloadProgress(data.item.id)"></file-download-ring>
                                    <i v-else class="icon icon-download"></i>
                                    <span>{{ getLocText('download_file') }}</span>
                                </span>
                            </span>
                        </template>
                        <template #cell(curr_ver)="data">
                            <span v-if="data.item.curr_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(past_ver)="data">
                            <span v-if="data.item.past_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(actions)="data">
                            <span v-if="showDeleteLinks || variantAttribute" class="col-delete"
                                  @click="delFile(data.item.category, data.item.id, data.item.file_name, getArrayByCategory(data.item.category))">
                                <i class="icon icon-close"></i>
                            </span>
                        </template>
                    </b-table>
                </b-tab>
                <b-tab>
                    <template #title>
                        {{ getFileTypeByCode('1007') }} (<span>{{(calculationFiles && calculationFiles.length > 0) ? calculationFiles.length : 0}}</span>)
                    </template>
                    <b-table
                        :fields="fileTableFields"
                        :items="fileItems(calculationFiles)"
                        small
                        hover
                        class="files-table"
                        no-sort-reset
                        :empty-text="getFmText('no_files')"
                        show-empty
                    >
                        <template #cell(file_name)="data">
                            <span class="col-file-cell">
                                <file-icons :filename="data.item.file_name"></file-icons>
                                <span @click="previewFile(data.item.file_name)"
                                        class="fileupload_file-name"
                                        :title="getTitleText(data.item.file_name)">{{data.item.file_name}}</span>
                                <span :class="['file-download-btn', { 'file-download-btn--disabled': getIsDownloading(data.item.id) }]" @click="downloadFile(data.item.file_name, data.item.id)">
                                    <file-download-ring v-if="getIsDownloading(data.item.id)" :progress="getDownloadProgress(data.item.id)"></file-download-ring>
                                    <i v-else class="icon icon-download"></i>
                                    <span>{{ getLocText('download_file') }}</span>
                                </span>
                            </span>
                        </template>
                        <template #cell(curr_ver)="data">
                            <span v-if="data.item.curr_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(past_ver)="data">
                            <span v-if="data.item.past_ver" class="version-check">&#10003;</span>
                        </template>
                        <template #cell(actions)="data">
                            <span v-if="showDeleteLinks || variantAttribute" class="col-delete"
                                  @click="delFile(data.item.category, data.item.id, data.item.file_name, getArrayByCategory(data.item.category))">
                                <i class="icon icon-close"></i>
                            </span>
                        </template>
                    </b-table>
                </b-tab>
                <template #tabs-end>
                    <li v-if="showDeleteAll && files.length" role="presentation" class="nav-item align-self-start">
                        <b-dropdown :disabled="isAllFileDownloading" variant="link" toggle-class="nav-link download-dropdown-toggle" no-caret>
                            <template #button-content>
                                <span class="download-toggle-text">{{ getLocText('download_file') }}</span>
                                <span v-if="isAllFileDownloading" style="position: relative; top: -10px; margin-left: 3px;">
                                    <file-download-ring :progress="allFileDownloadProgress"></file-download-ring>
                                </span>
                                <span v-else class="download-toggle-arrow">&#8250;</span>
                            </template>
                            <b-dropdown-item @click="(e) => downloadAllFile(e, false)" link-class="download-dropdown-item">
                                <span>{{ getLocText('download_all') }} ({{ files && files.length > 0 ? files.length : 0 }})</span>
                                <i class="icon icon-download"></i>
                            </b-dropdown-item>
                            <b-dropdown-item @click="downloadCurrVerFiles" link-class="download-dropdown-item">
                                <span>{{ getLocText('download_curr_ver') }} ({{ currVerFilesCount }})</span>
                                <i class="icon icon-download"></i>
                            </b-dropdown-item>
                        </b-dropdown>
                    </li>
                    <li v-if="variantAttribute && showDeleteAll && files.length" role="presentation" class="nav-item align-self-cente">
                        <p class="nav-link delete-all" @click="onDelAllFiles">
                            <i v-if="!deletigFiles" class="icon icon-close"></i>
                            <b-spinner v-if="deletigFiles" small variant="danger" label="Spinning"></b-spinner>
                            {{ getLocText('del_all') }} <span>({{files.length}})</span>
                        </p>
                    </li>
                </template>
            </b-tabs>
        </div>

         <!-- !!! эта модалка используется в форме расчета 149-03 в расшифровках. Учитывать при изменении   -->
        <b-modal ref="modalFileUpload" id="modal-file-upload" modal-class="modal-file-upload" v-model="modalFileUpload" @hidden="closeModal" centered hide-header hide-footer size="sm">
            <b-overlay :show="btnDisabled" rounded="sm">
                <div class="modal-title">{{ getLocText('select_cat') }}</div>
                <b-form-group>
                    <b-form-select v-model="selectedCategory" :options="categoryFiles" text-field="name"></b-form-select>
                </b-form-group>

                <b-form-file id="file"
                            :disabled="!selectedCategory"
                            accept="*.*"
                            v-model="file"
                            @input="uploadFile"
                            multiple
                            :placeholder="getLocText('upload')"
                ></b-form-file>
                <p class="upload-btn-label">({{ getLocText('max_size', {size: 50}) }})</p>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Ax } from '@/utils';
import axios from 'axios';
import store from "../../services/store";
import FileUpdownMixin from './mixins/file-updown-mixin';
import FileIcons from './components/file-icons.vue';
import FileDownloadRing from './components/file-download-ring.vue';

export default {
    name: 'FilesUpdown',
    components: { FileIcons, FileDownloadRing },
    props: {
        header: null,
        load: Boolean,
        variantAttribute: Boolean,
        showDeleteLinks: {
            type: Boolean,
            default: false
        },
        showDeleteAll: {
            type: Boolean,
            default: true
        },
        isPaidTab: {
            type: Boolean,
            required: false,
            default: false
        },
        variantName: {
            type: String,
            default: ''
        }
    },
    mixins: [FileUpdownMixin],
    data() {
        return {
            fileFields: [
                {
                    key: 'file_name',
                    label: 'Прикрепленные файлы'
                },
                {
                    key: 'size',
                    label: ''
                },
                {
                    key: 'more',
                    label: ''
                }
            ],
            files: [],
            selectedCategory: null,
            contractFiles: [],
            comOfferFiles: [],
            actFiles: [],
            estimateFiles: [],
            planFiles: [],
            conclusionFiles: [],
            calculationFiles: [],
            file: null,
            modalFileUpload: false,
            rowId: null,
            deletigFiles: false,
            btnDisabled: false,
            noPreviewExtentions: [
                '.7z', '.ace', '.arj', '.bin', '.bin', '.cab', '.cab', '.cbr', '.deb', '.exe', '.gz', 
                '.gzip', '.jar', '.one', '.pak', '.pak', '.pak', '.pkg', '.pkg', '.pkg', '.pkg', 
                '.ppt', '.rar', '.rpm', '.sh', '.sib', '.sis', '.sisx', '.sit', '.sitx', '.spl', 
                '.spl', '.tar', '.tar-gz', '.tgz', '.xar', '.zip', '.zip', '.zipx'
            ],
            isFileDownloading: {},
            fileDownloadProgress: {},
            isAllFileDownloading: false,
            allFileDownloadProgress: 0
        };
    },

    created() {
        this.loadDict()
        this.$watch('load', this.loadFiles);        
    },

    methods: {
        buildArchiveName() {
            const h = this.header;
            const gu = h.mode === 'gkkp' ? h.gkkp : h.gu;
            const prg = String(h.prg).padStart(3, '0');
            const ppr = h.ppr != null ? String(h.ppr).padStart(3, '0') : '000';
            return `${gu}_${prg}_${ppr}_${h.form}_${this.variantName}.zip`;
        },

        async delFile(file_type, file_id, file_name, array) {
            this.$bvModal.msgBoxConfirm(
                this.getLocText('delete_file'),
                {
                    title: this.getLocText('confirmation'),
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: this.getLocText('yes'),
                    cancelTitle: this.getLocText('no'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        this.deleteFile(file_id, file_name, array, file_type);
                    }
                })
                .catch(error => {
                    this.makeToast('danger', this.getLocText('delete_err'), error.toString());
                });
        }, // удаление файла

        async deleteFile(file_id, file_name, array, file_type) {
            const that = this;
            const deletingFileBody = {
                file_id,
                file_name,
                header: this.header
            }
            try {
                let url = '/api-py/delete-file/';
                if (this.isPaidTab) url = '/api-py/delete-file-paid/';
                await this.$emit('delelteAttachedFile', file_name, file_type);
                const response = await fetch(url, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(deletingFileBody)
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {

                    const idx = array.findIndex(f => f.id === file_id);
                    if (idx !== -1) array.splice(idx, 1);
                    this.$emit('restetFilesList');
                    const newFiles = [];

                    that.files.forEach((file, index) => {
                        if (file.id !== file_id) {
                            newFiles.push(file)
                            this.$emit('fillFilesList', file);
                        }
                    });
                    that.files = newFiles
                    that.getFiles();
                    that.makeToast('success', this.getLocText('msg'), this.getLocText('file_deleted'));
                    this.$emit('delFile', file_id);
                } else {
                    that.makeToast('danger', this.getLocText('warning'), this.getLocText('delete_err'));
                }
            } catch {
                that.makeToast('danger', this.getLocText('warning'), this.getLocText('delete_err'));
            }
        }, // удаляет файл с хранилища

        onDelAllFiles() {
            this.$bvModal.msgBoxConfirm(
                this.getLocText('delete_all_file'),
                {
                    title: this.getLocText('confirmation'),
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: this.getLocText('yes'),
                    cancelTitle: this.getLocText('no'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if (value) {
                        this.deleteAllFiles();
                    }
                })
                .catch(error => {
                    this.makeToast('danger', this.getLocText('delete_err'), error.toString());
                });
        }, // удаление всех файлов

        async deleteAllFiles() {
            this.deletigFiles = true;
            const idToDel = [];
            this.files.forEach(file => {
                this.$set(file, 'file_hash', this.stringToUnicode(file.category + file.file_name));
                idToDel.push(file.id)
            })
            const data = {files: this.files, header: this.header, showDeleteLinks: this.showDeleteLinks}
            try {
                let url = '/api-py/delete-all-files/';
                if (this.isPaidTab) url = '/api-py/delete-all-files-paid/';
                const response = await fetch(url, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(data)
                });
                const result = await response.json();

                if ((response.status === 200) && (result.result === 'success')) {
                    this.files.splice(0);
                    this.contractFiles.splice(0);
                    this.comOfferFiles.splice(0);
                    this.actFiles.splice(0);
                    this.estimateFiles.splice(0);
                    this.planFiles.splice(0);
                    this.conclusionFiles.splice(0);
                    this.calculationFiles.splice(0);
                    idToDel.forEach(file_id => this.$emit('delFile', file_id))
                    this.$emit('delelteAttachedFile');
                    this.$emit('restetFilesList');
                    this.makeToast('success', this.getLocText('msg'), this.getLocText('files_deleted'));
                    this.deletigFiles = false;
                } else {
                    this.makeToast('danger', this.getLocText('warning'), this.getLocText('delete_err'));
                    this.deletigFiles = false;
                }
            } catch {
                this.makeToast('danger', this.getLocText('warning'), this.getLocText('delete_err'));
                this.deletigFiles = false;
            }
        },

       stringToUnicode(string) {
            let chr = '';
            if (string.length === 0) return hash;
            for (let i = 0; i < string.length; i++) {
                chr += string.charCodeAt(i);
            }
            return chr;
        },

        previewFile(fileName) {
            if (this.isUnsupportedExtention(fileName)) return;
            this.$emit('onFilePreview', fileName);
        },

        isUnsupportedExtention(fileName) {
            return this.noPreviewExtentions.includes(this.getFileExten(fileName));
        },

        getIsDownloading(file_id) {
            return this.isFileDownloading[file_id.toString()];
        },

        getDownloadProgress(file_id) {
            return this.fileDownloadProgress[file_id.toString()] || 0;
        },

        downloadFile(filename, file_id) {
            if (this.getIsDownloading(file_id)) return;
            const that = this;
            this.$set(this.isFileDownloading, file_id.toString(), true);
            this.$set(this.fileDownloadProgress, file_id.toString(), 0);

            let url = '/api-py/download-file/';
            if (this.isPaidTab) url = '/api-py/download-file-paid/';
            Ax(
                {
                    url: url + filename + '/' + JSON.stringify(that.header),
                    method: 'POST',
                    data: null,
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent) => {
                        if (progressEvent.total) {
                            const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                            this.$set(this.fileDownloadProgress, file_id.toString(), percent);
                        }
                    }
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    this.$set(this.isFileDownloading, file_id.toString(), false);
                    this.$set(this.fileDownloadProgress, file_id.toString(), 0);
                },
                (error) => {
                    this.$set(this.isFileDownloading, file_id.toString(), false);
                    this.$set(this.fileDownloadProgress, file_id.toString(), 0);
                    that.makeToast('danger', this.getLocText('download_err'), error.toString());
                }
            );
        }, // скачать файл

        downloadAllFile(event, filesArr = false, tracker = null) {
            if (event) event.preventDefault();
            const that = this;
            const allFileNames = [];
            const files = filesArr || that.files;
            files.forEach(file => {
                allFileNames.push(file.file_name);
            });

            if (allFileNames && allFileNames.length > 0) {
                this.downloadAllFileReqst(allFileNames, tracker);
            }
        }, // скачать архив всех прикрепленных файлов

        downloadAllFileReqst(allFileNames, tracker = null) {
            if (tracker) {
                this.$set(tracker, 'isDownloading', true);
                this.$set(tracker, 'progress', 0);
            } else {
                this.isAllFileDownloading = true;
                this.allFileDownloadProgress = 0;
            }
            const usrId = store.state.user.sub;
            const downloadData = {
                allFileNames,
                header: this.header
            }
            let url = '/api-py/download-all-file/';
            if (this.isPaidTab) url = '/api-py/download-all-file-paid/';
            Ax(
                {
                    url: url + usrId + '/' + this.header.mode,
                    method: 'POST',
                    onDownloadProgress: (progressEvent) => {
                        if (progressEvent.total) {
                            const pct = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                            if (tracker) {
                                this.$set(tracker, 'progress', pct);
                            } else {
                                this.allFileDownloadProgress = pct;
                            }
                        }
                    },
                    data: downloadData,
                    responseType: 'blob'
                },
                async (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.buildArchiveName());
                    document.body.appendChild(link);
                    link.click();
                    await axios.post('/api-py/delete-zip-file-by-name/' + usrId); // запрос чтобы удалить сгенерированный архив
                    if (tracker) {
                        this.$set(tracker, 'isDownloading', false);
                        this.$set(tracker, 'progress', 0);
                    } else {
                        this.isAllFileDownloading = false;
                        this.allFileDownloadProgress = 0;
                    }
                },
                async (error) => {
                    if (tracker) {
                        this.$set(tracker, 'isDownloading', false);
                        this.$set(tracker, 'progress', 0);
                    } else {
                        this.isAllFileDownloading = false;
                        this.allFileDownloadProgress = 0;
                    }
                    that.makeToast('danger', this.getLocText('download_err'), error.toString());
                    await axios.post(delZipUrl + usrId); // запрос чтобы удалить сгенерированный архив
                }
            );
        },

        downloadCurrVerFiles() {
            const currVerFiles = this.files.filter(f => f.is_current_version);
            this.downloadAllFile(null, currVerFiles);
        },

        fileItems(arr) {
            return arr.map(f => ({
                ...f,
                curr_ver: f.is_current_version ? 1 : 0,
                past_ver: f.is_current_version ? 0 : 1,
            }));
        },

        getArrayByCategory(category) {
            const map = {
                '1001': this.contractFiles,
                '1002': this.comOfferFiles,
                '1003': this.actFiles,
                '1004': this.estimateFiles,
                '1005': this.planFiles,
                '1006': this.conclusionFiles,
                '1007': this.calculationFiles,
            };
            return map[category] || [];
        },

        getFiles() {
            const data = this.files;
            this.$emit('getFiles', data);
        },

        async loadFiles() {
            const that = this;
            if (that.load) {
                this.$emit('restetFilesList');
                that.files.splice(0);
                try {
                    let url = '/api-py/get-files/';
                    if (this.isPaidTab) url = '/api-py/get-files-paid/';
                    const response = await fetch(url + JSON.stringify(that.header));
                    that.files = await response.json();
                    that.contractFiles = [];
                    that.comOfferFiles = [];
                    that.actFiles = [];
                    that.estimateFiles = [];
                    that.planFiles = [];
                    that.conclusionFiles = [];
                    that.calculationFiles = [];
                    that.files.forEach(f => {
                        this.fillArrsByCategory(f);
                    });
                    that.getFiles();
                } catch (error) {
                    that.makeToast('danger', this.getLocText('get_files_err'), error.toString());
                }
            }
        },

        fillArrsByCategory(item) {
            const that = this;
            const category = item.category;
            switch (category) {
                case '1001':
                    that.contractFiles.push(item);
                    break;
                case '1002':
                    that.comOfferFiles.push(item);
                    break;
                case '1003':
                    that.actFiles.push(item);
                    break;
                case '1004':
                    that.estimateFiles.push(item);
                    break;
                case '1005':
                    that.planFiles.push(item);
                    break;
                case '1006':
                    that.conclusionFiles.push(item);
                    break;
                case '1007':
                    that.calculationFiles.push(item);
                    break;
            }

            this.$emit('fillFilesList', item);
        },

        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        }, // сообщение

        openModalFileUpload() {
            this.modalFileUpload = !this.modalFileUpload;
            this.rowId = null;
        },

        setRowId(row_id) {
            this.rowId = row_id;
        },

        closeModal() {
            this.selectedCategory = null;
        },

        async uploadFile() {
            if (this.selectedCategory === null) {
                this.makeToast('danger', this.getLocText('msg'), this.getLocText('cat_not_selected'));
                this.file = null;
            } else {
                const newAddedFiles = [];
                const that = this;
                for (let i = 0; i < that.file.length; i++) {
                    const formData = new FormData();
                    formData.append('file', that.file[i], that.file[i].name);
                    this.btnDisabled = true;
                    let url = '/api-py/upload-file/';
                    if (this.isPaidTab) url = '/api-py/upload-file-paid/';
                    await axios.post(url + JSON.stringify(that.header) + '/' + that.selectedCategory,
                        formData,
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'multipart/form-data'
                        }
                    )
                        .then(response => {
                            if (response.data && response.data.existed) {
                                that.makeToast('danger', this.getLocText('msg'), this.getLocText('file_exist', {fileName: that.file[i].name}));
                            } else {
                                const resp = response.data;
                                
                                const one_file = {
                                    id: resp.id,
                                    file_name: that.file[i].name,
                                    size: resp.size,
                                    category: resp.category,
                                    createdTime: resp.createdTime,
                                    variant_load: that.header.variant,
                                    is_current_version: true,
                                }
                                that.fillArrsByCategory({
                                    ...one_file,
                                    new_file: true
                                });
                                that.files.push({
                                    ...one_file,
                                });
                                newAddedFiles.push({
                                    id: null,
                                    file_id: resp.id,
                                    file_name: that.file[i].name,
                                    file_type: resp.category,
                                    row_id: this.rowId,
                                    createdTime: resp.createdTime,
                                    variant_load: that.header.variant,
                                    is_current_version: true,
                                });
                                that.makeToast('success', this.getLocText('msg'), this.getLocText('upload_success', {fileName: that.file[i].name}));
                            }
                        })
                        .catch((error) => {
                            that.makeToast('danger', this.getLocText('warning'), error.toString());
                        })
                        .finally(() => this.btnDisabled = false)
                }
                this.$emit('getNewFiles', newAddedFiles);
                that.getFiles();
                that.file = null;
            }
        }, // скачать файл

        showModalFileUpload() {
            this.$refs.modalFileUpload.show();
        },
    
        getFileExten(fileName) {
            const lastIndex = fileName.lastIndexOf('.');
            if (lastIndex === -1) {
                return ''; 
            } else {
                return fileName.substring(lastIndex).toLowerCase();
            }
        },

        getTitleText(fileName) {
            if (this.isUnsupportedExtention(fileName)) {
                return this.getLocText('unsupported_format');
            }
            else {
                return this.getLocText('preview_file');
            }
        },
        
        getFmText(field, extra = null) {
            const link = 'modules.budget_request.files_management.';
            return this.getText(link, field, extra)
        },
    },
    computed: {
        fileTableFields() {
            return [
                { key: 'createdTime', label: this.getLocText('date'), sortable: false },
                { key: 'file_name',   label: this.getLocText('file'), sortable: false },
                { key: 'size',        label: this.getLocText('size'), sortable: false },
                { key: 'curr_ver',    label: this.getLocText('current_version'), sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'past_ver',    label: this.getLocText('past_versions'),   sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'actions',     label: this.getLocText('delete'),           sortable: false, thClass: 'text-center', tdClass: 'text-center' },
            ];
        },
        currVerFilesCount() {
            if (!this.files) return 0;
            return this.files.filter(f => f.is_current_version).length;
        }
    },
    watch: {
        header: {
            immediate: true,
            handler() {
                this.loadFiles();
            }
        }
    }
};
</script>

<style scoped>
::v-deep .download-dropdown-item {
    display: flex !important;
    justify-content: space-between  !important;
    align-items: center;
    width: 100%;
    min-width: 220px;
    color: #2196F3 !important;
    font-size: 0.7777777778rem;
    font-weight: 400;
}
::v-deep .download-dropdown-item span {
    flex: 1;
    text-align: left;
    color: #2196F3;
    font-size: 0.7777777778rem;
    font-weight: 400;
}
::v-deep .download-dropdown-item .icon {
    color: #2196F3;
    flex-shrink: 0;
    margin-left: 12px;
    font-size: 0.7777777778rem;
}
::v-deep .files-table th {
    font-size: 0.75rem;
    color: #6087A0;
    white-space: nowrap;
    background-color: #F7F9FC;
}
::v-deep .files-table td {
    font-size: 0.8rem;
    vertical-align: middle;
    line-height: 1.5;
}
.col-file-cell {
    display: flex;
    align-items: center;
    gap: 6px;
    overflow: hidden;
}
.col-delete {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.col-delete .icon-close {
    transition: transform 0.15s ease, color 0.15s ease;
    color: #9e9e9e;
}
.col-delete:hover .icon-close {
    transform: translateY(-2px) scale(1.2);
    color: #d32f2f;
}
.version-check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #43A047;
    color: #43A047;
    font-size: 11px;
    font-weight: bold;
}
.delete-all {
    color: #d34641 !important;
    cursor: pointer;
}
.delete-all i {
    font-size: 0.6rem;
}
.upload-btn-label {
    font-size: 0.6rem;
    font-style: italic;
    opacity: 0.6;
}
.fileupload_file-name {
    cursor: pointer;
    transition: transform 0.15s ease;
    align-self: center;
}
.fileupload_file-name:hover {
    transform: translateY(-2px);
}
.fileupload .icon-download {
    color: #2196F3 !important;
}
.download-toggle-text {
    color: #2196F3;
    align-self: start;
}
.download-toggle-arrow {
    color: #2196F3;
    display: inline-block;
    transform: rotate(90deg);
    font-size: 1.2rem;
    line-height: 0.7;
    margin-left: 2px;
    align-self: start;
}
::v-deep .download-dropdown-toggle,
::v-deep .download-dropdown-toggle:focus,
::v-deep .download-dropdown-toggle:active,
::v-deep .download-dropdown-toggle:hover {
    box-shadow: none !important;
    border: none !important;
    background: none !important;
    padding: 0;
    text-decoration: none;
    outline: none;
}
.file-download-btn {
    margin-left: auto;
    margin-right: 1rem;
    flex-shrink: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    transition: transform 0.15s ease;
}
.file-download-btn:hover {
    transform: translateY(-2px);
}
.file-download-btn--disabled {
    pointer-events: none;
    opacity: 0.5;
}
.file-download-btn,
.file-download-btn span {
    color: #2196F3 !important;
}

.fileupload .action_btn {
    margin-right: 20px;
}

.fileupload .action_btn:active,
.fileupload .action_btn:active * {
    color: #2b3c47;
}

.fileupload .spinner {
    margin-right: 4px;
    height: 12px;
    width: 12px;
}

.fileupload .load-block {
    padding-left: 15px;
}

</style>